import PromptInput from "common/widgets/PromptList/PromptInput";

export default PromptInput.extend({

    options: {
        name: "ImagePromptInput",
        template: "<img>"
    },

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        this.input.attr("src", this.options.model.imageName);
        this.refresh();
    },

    canFocus: function() {
        return false;
    },

    // Do nothing - non-input type prompt has no value
    updateWidgetValue: $.noop,

    // Do nothing - non-input type prompt has no value
    value: $.noop

});
